import { Link } from "react-router-dom";
import { useState } from "react";

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-gray-100 px-8 py-4">
      <div className="flex justify-between items-center">
        {/* Logo */}
        <div>
          <Link to="/" className="text-2xl font-semibold">
            Consent Talk
          </Link>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center">
          <Link to="/faq" className="text-l font-semibold mx-4">
            FAQ
          </Link>
          <div className="flex text-m">
            <p className="mr-1">supported by</p>
            <a
              className="text-blue-500"
              href="https://policytalk.ca"
              target="_blank"
              rel="noopener noreferrer"
            >
              Policy Talk
            </a>
          </div>
        </div>

        {/* Hamburger Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden focus:outline-none"
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isOpen ? (
              // X icon when open
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              // Hamburger icon when closed
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden mt-4 pb-4 border-t border-gray-300 pt-4">
          <Link
            to="/faq"
            className="block text-l font-semibold py-2"
            onClick={() => setIsOpen(false)}
          >
            FAQ
          </Link>
          <div className="flex text-m py-2">
            <p className="mr-1">supported by</p>
            <a
              className="text-blue-500"
              href="https://policytalk.ca"
              target="_blank"
              rel="noopener noreferrer"
            >
              Policy Talk
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}

export default NavBar;
